import styled from 'styled-components';
import { ICON_MAIL } from '@repo/assets';
import { Modal } from '@successmode-ktp/kui';
import { ANSEWERED_MODAL } from '@repo/constants';

type Props = {
  isOpen: boolean;
  onClick: () => void;
  lang?: 'KOR' | 'ENG';
};

export const AnswerdModal = ({ isOpen, onClick, lang = 'ENG' }: Props) => {
  return (
    <Modal
      isOpen={isOpen}
      hasBackdrop
      wrapperStyle={{ width: '100%', maxWidth: '320px' }}
    >
      <Modal.Header>
        <TitleWrapper>
          <img src={ICON_MAIL} alt='' width={36} />
          <h6>{ANSEWERED_MODAL[lang].title}</h6>
        </TitleWrapper>
      </Modal.Header>
      <ModalBody>{ANSEWERED_MODAL[lang].contents}</ModalBody>
      <Modal.Footer>
        <Modal.Button type='button' onClick={onClick}>
          {ANSEWERED_MODAL[lang].btnText}
        </Modal.Button>
      </Modal.Footer>
    </Modal>
  );
};

const TitleWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  gap: 16px;
`;

const ModalBody = styled.p`
  display: block;
  margin-top: 16px;
  color: #80848a;
  text-align: center;
  font-size: 14px;
  font-weight: 500;
  line-height: 150%;
  letter-spacing: -0.28px;
`;
